import { getHttpApi } from '@cian/http-api/browser';
import { getConfig } from '@cian/config/browser';
import {
  fetchSearchRegionsCities,
  TSearchRegionsCitiesResponse,
} from '../../../../../../shared/repositories/monolith-python/v1/search-regions-cities';

export const searchCitiesRegions = (text: string): Promise<TSearchRegionsCitiesResponse> =>
  fetchSearchRegionsCities({
    httpApi: getHttpApi(),
    parameters: {
      text,
    },
    config: { subdomain: getConfig().getStrict<string>('subdomain') },
  });
